import { Discount } from '@core/services/DiscountHandler/Model/Discount';
import { Vigencia } from '@core/services/DiscountHandler/Model/Vigencia';
import { Alcance } from '../../core/services/DiscountHandler/Model/Alcance';

export class DiscountCartClass {
  id?: number;
  identificador?: string;
  percent?: number;
  maxDiscountPrice?: number;
  reach?: Alcance[];
  validity?: Vigencia[];
  discount?: Discount;
  constructor(discount: Discount) {
    this.discount = discount;
    this.id = discount.id;
    this.percent = discount.porcentaje;
    this.maxDiscountPrice = discount.monto_maximo;
    this.reach = discount.alcances;
    this.validity = discount.vigencias;
  }
}
